/* tslint:disable */
/* eslint-disable */
/**
 * Private UI API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: ${project.version}
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import {
    FirmwareType,
    FirmwareTypeFromJSON,
    FirmwareTypeFromJSONTyped,
    FirmwareTypeToJSON,
} from './FirmwareType';

/**
 * 
 * @export
 * @interface RescueFirmwareResponse
 */
export interface RescueFirmwareResponse {
    /**
     * 
     * @type {string}
     * @memberof RescueFirmwareResponse
     */
    id: string;
    /**
     * 
     * @type {FirmwareType}
     * @memberof RescueFirmwareResponse
     */
    type: FirmwareType;
    /**
     * 
     * @type {string}
     * @memberof RescueFirmwareResponse
     */
    denormVersion: string;
}

export function RescueFirmwareResponseFromJSON(json: any): RescueFirmwareResponse {
    return RescueFirmwareResponseFromJSONTyped(json, false);
}

export function RescueFirmwareResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): RescueFirmwareResponse {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'id': json['id'],
        'type': FirmwareTypeFromJSON(json['type']),
        'denormVersion': json['denormVersion'],
    };
}

export function RescueFirmwareResponseToJSON(value?: RescueFirmwareResponse | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'id': value.id,
        'type': FirmwareTypeToJSON(value.type),
        'denormVersion': value.denormVersion,
    };
}

